
import '~/js/views/general/includes/scroll-below';
import '~/js/views/resorts/includes/slider-inclusions';
import '~/js/views/resorts/includedCards';
import '~/js/views/resorts/includes/slider-top';
import '~/js/views/resorts/includes/slider-inclusions';
import '~/js/views/resorts/includes/slider-featured-suites';
import '~/js/views/resorts/includes/slider-highlights.js';

const $diningSlider = $('.js-dining-slider');
const $diningSliderControls = $('.js-slider-controls');

/** Dining Slider */
const preloadSlide = ($slider, currentSlide = 0) => {
    const $currentSlide = $slider.$slider.find('.slick-current');
    const $allCloned = $currentSlide.nextAll('.slick-cloned');
    const $currentCloned = $($allCloned[currentSlide]);
    const $prevSlide = $currentSlide.prev();
    const $nextSlide = $currentSlide.next();

    const setDataSrc = ($slide) => {
        $slide.find('[data-src]').each((index, el) => {
            el.src = el.dataset.src;
            delete el.dataset.src;
        });
    };

    setDataSrc($currentSlide);
    setDataSrc($currentCloned);
    setDataSrc($prevSlide);
    setDataSrc($nextSlide);
};

$diningSlider.on('init reInit afterChange', (event, slick, currentSlide) => {
    preloadSlide(slick, currentSlide);
});

$diningSlider.slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    appendArrows: $diningSliderControls,
    prevArrow: '<span aria-hidden="true" class="slick-arrow-prev"></span>',
    nextArrow: '<span aria-hidden="true" class="slick-arrow-next"></span>'
});

$diningSlider.on('afterChange', (event, slick, currentSlide) => {
    const $imagePrevObj = $diningSlider.find(`div[data-slick-index="${currentSlide - 1}"]`).find('.dining-slide img');
    const $imageNextObj = $diningSlider.find(`div[data-slick-index="${currentSlide + 1}"]`).find('.dining-slide img');
    const imagePrevSrc = $imagePrevObj.data('lazy');
    const imageNextSrc = $imageNextObj.data('lazy');

    if (imagePrevSrc !== $imagePrevObj.attr('src')) {
        $imagePrevObj.attr('src', imagePrevSrc);
    }
    if (imageNextSrc !== $imageNextObj.attr('src')) {
        $imageNextObj.attr('src', imageNextSrc);
    }
});
